<form [formGroup]="form" *ngIf="form">
  <ion-item-divider color="light">
    <ion-label>{{ dividerTitle  | translate }}</ion-label>
  </ion-item-divider>

  <ion-row>
    <!-- Number of Games -->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Games' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfGames">
          <ion-select-option [value]="1">1</ion-select-option>
          <ion-select-option [value]="3">3</ion-select-option>
          <ion-select-option [value]="5">5</ion-select-option>
          <ion-select-option [value]="7">7</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>

    <!-- Points per Game -->
    <ion-col>
      <ion-item>
        <ion-select label="{{ 'Points per game' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfPoints">
          <ion-select-option [value]="11">11</ion-select-option>
          <ion-select-option [value]="15">15</ion-select-option>
          <ion-select-option [value]="21">21</ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>
  </ion-row>
</form>
